import { LoadScript } from '@react-google-maps/api';

function GoogleMapInitiator({ children }) {
  return (
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_KEY}
      libraries={['geometry', 'drawing', 'places', 'visualization']}
      version="3"
    >
      {children}
    </LoadScript>
  );
}

export default GoogleMapInitiator;
